import { JSX } from "react"
import { HeroShared, TalentShared } from "../../../../api/repositories/cdn/models/shared"
import { SharedHeroTalent } from "../../../../common/constants"
import { HeroImage, TalentSharedImage } from "../../ui/file-contents"

export const HeroDetailsBlock: React.FC<{
    isNewGen: boolean
    heroDetails: HeroShared
    hero: Hero
}> = ({ heroDetails, hero, isNewGen }) => {
    const skills: string[] = isNewGen ? [SharedHeroTalent] : [];
    Object.keys(heroDetails.orangeTalents).forEach(f => skills.push(f));

    const skillBlocks = skills.map((skill, si) => (
        <SkillBlock
            key={skill}
            heroDetails={heroDetails}
            heroName={hero.name}
            isNewGen={isNewGen}
            skill={skill}
        />
    ));

    const resultBlocks: JSX.Element[] = [];
    skillBlocks.forEach((block, i) => {
        resultBlocks.push(block);
        if (i < skillBlocks.length - 1) {
            resultBlocks.push(
                <div
                    key={`divider-${i}`}
                    className="h-[2px] lg:w-[2px] w-[240px] lg:h-[240px] bg-[#ffffff0d]"
                />
            );
        }
    });

    return (
        <div className="flex flex-col lg:flex-row items-center lg:items-start justify-center lg:justify-between gap-[40px] 2xl:gap-[] 
        xl:gap-[50px] text-center lg:text-left">
            {resultBlocks}
        </div>
    );
};

const SkillBlock: React.FC<{
    heroName: string
    skill: string
    isNewGen: boolean
    heroDetails: HeroShared
}> = ({ heroName, skill, isNewGen, heroDetails }) => {
    return <div
        key={skill}
        className={`${isNewGen && skill == SharedHeroTalent ? '' : ''} w-[300px] lg:w-full flex flex-col relative items-center`}
    >
        <div className="relative">
            <div
                style={{ filter: "blur(45px)" }}
                className="absolute inset-0 bg-orange-500 z-[-1] top-[15px] left-[-40px] w-[150px]"
            />
            {
                isNewGen
                    ? skill == SharedHeroTalent
                        ? <HeroImage className="border-orange" heroName={heroName} size="136x78" />
                        : <TalentSharedImage
                            className="w-[80px] border-orange"
                            heroName={heroName}
                            path={heroDetails.orangeTalents[skill][0].image}
                            dataTooltipHtml={heroDetails.orangeTalents[skill][0].description}
                            dataTooltipId='talent'
                        />
                    : <TalentSharedImage
                        className="w-[80px] h-[80px] border-orange"
                        heroName={heroName}
                        path={heroDetails.orangeTalents[skill][0].image}
                        dataTooltipHtml={heroDetails.orangeTalents[skill][0].description}
                        dataTooltipId='talent'
                    />
            }
        </div>
        <div className="relative ">
            <div
                style={{ filter: "blur(55px)" }}
                className="absolute inset-0 bg-purple-500 z-[-1]"
            />
            <TalentsBlock
                heroName={heroName}
                talents={heroDetails.purpleTalents[skill]}
                type="purple"
            />
        </div>
        <div className="relative">
            <div
                style={{ filter: "blur(55px)" }}
                className="absolute inset-0 bg-blue-500 z-[-1]"
            />
            <TalentsBlock
                heroName={heroName}
                talents={heroDetails.blueTalents[skill]}
                type="blue"
            />
        </div>
    </div>
}

const TalentsBlock: React.FC<{
    heroName: string
    talents: TalentShared[]
    className?: string
    type: 'purple' | 'blue'
}> = ({ type, className, talents, heroName }) => {
    return <div className={`flex items-center gap-[18px] mt-[18px] relative ${className ?? ''}`}>
        {talents.map((talent, i) => {
            return (
                <div key={i} data-tooltip-id='talent' data-tooltip-html={talent.description}>
                    <div
                        className={`flex flex-col border-${type} p-[4px]`}>
                        <TalentSharedImage
                            key={talent.modName}
                            className="w-[45px] w-[45px]"
                            heroName={heroName}
                            path={talent.image}
                        />
                        <div className="flex flex-row gap-[4px] mt-[4px]">
                            {
                                Array.from({ length: talent.levels }, (_, i) => (
                                    <div key={i + talent.modName}
                                        className={`w-full h-[10px] bg-${type}`} />
                                ))
                            }
                        </div>
                    </div>
                </div>
            );
        })}
    </div>
}